export const PRIMARY = {
  lightRed: "hsl(0, 100%, 67%)",
  orangeyYellow: "hsl(39, 100%, 56%)",
  greenTeal: "hsl(166, 100%, 37%)",
  cobaltBlue: "hsl(234, 85%, 45%)",
  darkNavyBlue: "hsl(223, 30%, 27%)"
};

export const PRIMARY_WITH_OPACITY = {
  lightRed: "hsla(0, 100%, 67%, 0.15)",
  orangeyYellow: "hsla(39, 100%, 56%, 0.15)",
  greenTeal: "hsla(166, 100%, 37%, 0.15)",
  cobaltBlue: "hsla(234, 85%, 45%, 0.15)",
  darkNavyBlue: "hsla(223, 30%, 27%, 0.5)",
  lightLavender: "hsla(241, 100%, 89%, 0.5)",
  persianBlueCircle: "hsla(241, 72%, 46%, 0.6)",
};

export const GRADIANTS = {
  lightSlateBlueBackground: "hsl(252, 100%, 67%)",
  mediumSlateBlueBackground: "hsl(252, 100%, 63%)",
  lightRoyalBlueBackground: "hsl(241, 81%, 54%)",

  violetBlueCircle: "hsla(256, 72%, 46%, 1)",
  persianBlueCircle: "hsla(241, 72%, 46%, 0)",
};

export const NEUTRAL = {
  white: "hsl(0, 0%, 100%)",
  paleBlue: "hsl(221, 100%, 96%)",
  lightLavender: "hsl(241, 100%, 89%)",
  darkGrayBlue: "hsl(224, 30%, 27%)",
};
